import ActionBar from './ActionBar'
import {ContentWrapper, LeftColumnWrapper, RightColumnWrapper, PageWrapper} from 'components/wrappers/pages'
import List from './List'
import {pageRequest} from 'actions/inventory/summary'
import {connect} from 'react-redux'
import {getFormValues} from 'redux-form'
import ListSummaryIngredients from './ListSummaryIngredients'
import NoDataAndLoading from 'components/NoDataAndLoading'
import {browserHistory} from 'react-router'

class Summary extends React.Component {
  render () {
    let {showLoadingSpinnerPage, search, items, ingredients} = this.props
    const expireTime = 365 // expire time 1 year
    if (Cookies.get('labelNew') === 'true') {
      Cookies.set('labelNew', 'false', { path: '/', domain: '.mokapos.com', expires: expireTime })
    }
    return (<PageWrapper>
      <ActionBar />
      <ContentWrapper>
        <LeftColumnWrapper>
          <NoDataAndLoading
            showLoadingSpinner={showLoadingSpinnerPage}
            noDataToDisplay={(search && search.namespace !== 'ingredients') ? items.length === 0 : ingredients.length === 0}
            title='No Data To Display'
            description='' />
          {search && search.namespace !== 'ingredients'
            ? <List />
            : <ListSummaryIngredients />}
        </LeftColumnWrapper>
        <RightColumnWrapper />
      </ContentWrapper>
    </PageWrapper>)
  }

  componentDidMount () {
    const {dispatch, expired} = this.props
    if (!expired) {
      dispatch(pageRequest())
    } else {
      browserHistory.push('/settings/billing')
    }
  }
}

function mapStateToProps (state) {
  const {showLoadingSpinnerPage} = state.loadingSpinner
  const {items, ingredients} = state.inventory.summary
  const {expired} = state.subscriptionExpired
  return {
    showLoadingSpinnerPage,
    search: getFormValues('search')(state),
    items,
    ingredients,
    expired
  }
}

function mapDispatchToProps (dispatch) {
  return {dispatch}
}

export default connect(mapStateToProps, mapDispatchToProps)(Summary)



// WEBPACK FOOTER //
// ./app/pages/Inventory/Summary/Summary.js